import { LegalClientEntity, LegalClientHeadEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { DialogStateProps } from 'libs/ui';
import { AddDialogForm } from 'modules/client/common/components';

import { LegalClientAddHeadSections } from '../components';
import { useLegalClientAddHead } from '../hooks';

interface Props extends DialogStateProps {
  legalClient: LegalClientEntity;
  onSuccess: (legalClientHead: LegalClientHeadEntity) => void;
}

export const LegalClientAddHeadDialogFeature = ({
  legalClient,
  isOpen,
  onClose,
  onSuccess,
}: Props) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    validationSchema,
    formError,
    submitLoading,
    onSubmit,
  } = useLegalClientAddHead(legalClient, onSuccess);

  const { t } = useTranslation();

  return (
    <AddDialogForm
      initialErrors={formError}
      initialValues={initialValues}
      isOpen={isOpen}
      submitLoading={submitLoading}
      title={t('client.legal.legalClientHead.addDialog.title')}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <LegalClientAddHeadSections
        bodies={legalClient.bodies ?? []}
        countries={countries ?? []}
        countriesLoading={countriesLoading}
      />
    </AddDialogForm>
  );
};
